import React from 'react';
import PropTypes from 'prop-types';

import { TooltipStyled } from './Tooltip.styled';

export const tooltipPlace = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
};

export const tooltipEffect = {
  FLOAT: '',
  SOLID: 'solid',
};

/**
 * **Tooltip** component displays informative text when users hover over, focus on, or tap an element.
 */

export default function Tooltip({ children = null, ...rest }) {
  return <TooltipStyled {...rest}>{children}</TooltipStyled>;
}

Tooltip.defaultProps = {
  place: tooltipPlace.BOTTOM,
  effect: tooltipEffect.SOLID,
};

Tooltip.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
    Needed if we render the tooltip inside a map, also using data-for on the element that triggers the tooltip
   */
  id: PropTypes.string,
  /**
    Behaviour of tooltip
  */
  effect: PropTypes.oneOf(Object.values(tooltipEffect)),
  /**
    The placement of the tooltip in relation to the element that shows it
   */
  place: PropTypes.oneOf(Object.values(tooltipPlace)),
  /**
    Delay time to be shown in miliseconds
   */
  delayShow: PropTypes.number,
  /**
    Delay time to be hidden in miliseconds
   */
  delayHide: PropTypes.number,
  /**
   * Allows a tooltip to directly display raw HTML.
   */
  html: PropTypes.bool,
};
